import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest } from "../services";
import toast from "react-hot-toast";

const initialState = {
    studentProfileReports: [],
    loading: false,
    error: null,
};

// Fetch student profile reports by section ID
export const fetchStudentProfileReports = createAsyncThunk(
    "studentProfileReport/fetchStudentProfileReports",
    async (sectionId, { rejectWithValue }) => {
        try {
            const response = await getRequest(`/api/Reports/StudentReport?sectionId=${sectionId}`);
            console.log("Student Profile Reports API Response:", response.data);
            if (response.status !== 200) throw new Error("Failed to fetch student profile reports");
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const studentProfileReportSlice = createSlice({
    name: "studentProfileReport",
    initialState,
    reducers: {
        clearStudentProfileReports: (state) => {
            state.studentProfileReports = [];
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchStudentProfileReports.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchStudentProfileReports.fulfilled, (state, action) => {
                state.loading = false;
                state.studentProfileReports = action.payload;
            })
            .addCase(fetchStudentProfileReports.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                toast.error(action.payload || "Failed to fetch student profile reports");
            });
    },
});

export const { clearStudentProfileReports } = studentProfileReportSlice.actions;
export default studentProfileReportSlice.reducer;

